module.exports = __webpack_public_path__ + "static/img/patient_copy.a90c82ee.png";